import {
  Identifiable,
  Planzone,
  ResourcesListingConfiguration,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function getDefaultConf(): ResourcesListingConfiguration {
  return [
    {
      name: "Admin",
      roles: ["pz_admin"],
      columns: [{ key: "tags" }, { key: "role" }, { key: "invitationStatus" }],
    },
    {
      name: "Others",
      roles: [
        "pz_under_admin",
        "pz_user",
        "pz_visitor",
        "pr_visitor",
        "pr_manager",
        "pr_worker",
      ],
      columns: [{ key: "tags" }, { key: "role" }, { key: "invitationStatus" }],
    },
  ];
}

function getResourcesListingConfiguration(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: `/planzones/${planzone.uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ data }) =>
        !!data.resourcesListingViewConfigurations
          ? JSON.parse(data.resourcesListingViewConfigurations)
          : getDefaultConf(),
      );
}

export { getResourcesListingConfiguration };
